import { render, staticRenderFns } from "./SelectionItem.vue?vue&type=template&id=7f5c5184&scoped=true"
import script from "./SelectionItem.vue?vue&type=script&lang=js"
export * from "./SelectionItem.vue?vue&type=script&lang=js"
import style0 from "./SelectionItem.vue?vue&type=style&index=0&id=7f5c5184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c5184",
  null
  
)

export default component.exports